/**
 * Appends a small arrow icon to every primary/secondary button so the
 * hover-tilt micro-interaction (see base.css) has something to rotate.
 * Runs on load and watches for buttons added later (AJAX cart, quick-add
 * modals, theme editor section re-renders) via MutationObserver.
 */
(function () {
  var ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10" aria-hidden="true">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/>' +
    '</svg>';

  function addArrow(button) {
    if (button.querySelector(':scope > .button__arrow')) return;
    var span = document.createElement('span');
    span.className = 'button__arrow';
    span.innerHTML = ARROW_SVG;
    button.appendChild(span);
  }

  var SELECTOR = '.button--primary, .button--secondary, .header__shop-now-button';

  function scan(root) {
    root.querySelectorAll(SELECTOR).forEach(addArrow);
    if (root.matches && root.matches(SELECTOR)) {
      addArrow(root);
    }
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
